import api from "./api";

function urlBase64ToUint8Array(base64String) {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
  const raw = window.atob(base64);
  const out = new Uint8Array(raw.length);
  for (let i = 0; i < raw.length; i++) out[i] = raw.charCodeAt(i);
  return out;
}

export async function registerServiceWorker() {
  if (!("serviceWorker" in navigator)) return null;
  try {
    return await navigator.serviceWorker.register("/sw.js");
  } catch {
    return null;
  }
}

export async function enablePush() {
  if (!("serviceWorker" in navigator) || !("PushManager" in window)) return { ok: false, reason: "unsupported" };
  const perm = await Notification.requestPermission();
  if (perm !== "granted") return { ok: false, reason: "denied" };
  const reg = await navigator.serviceWorker.ready;
  const { data } = await api.get("/chat/push/public-key");
  if (!data.public_key) return { ok: false, reason: "no-vapid" };
  const appKey = urlBase64ToUint8Array(data.public_key);
  let sub = await reg.pushManager.getSubscription();
  // If an existing subscription was made with a different VAPID key, drop it and re-subscribe.
  if (sub) {
    const existing = new Uint8Array(sub.options?.applicationServerKey || []);
    const sameKey = existing.length === appKey.length && existing.every((b, i) => b === appKey[i]);
    if (!sameKey) {
      try { await sub.unsubscribe(); } catch (e) {}
      sub = null;
    }
  }
  if (!sub) {
    try {
      sub = await reg.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: appKey,
      });
    } catch (e) {
      return { ok: false, reason: "error", message: e?.message || String(e) };
    }
  }
  await api.post("/chat/push/subscribe", { subscription: sub.toJSON() });
  return { ok: true };
}

// Update the home-screen / taskbar app icon badge with an unread count.
export function setAppBadge(count) {
  try {
    if (count > 0 && "setAppBadge" in navigator) navigator.setAppBadge(count).catch(() => {});
    else if ("clearAppBadge" in navigator) navigator.clearAppBadge().catch(() => {});
  } catch (e) { /* unsupported */ }
}
